import { MULTIPLE_CHOICES, OK, UNAUTHORIZED } from '../constants/http-status';

export const isSuccessful = (status: number) => status >= OK && status < MULTIPLE_CHOICES;

export const isUnauthorized = (status: number) => status === UNAUTHORIZED;
